import { useMutation } from "@tanstack/react-query";
import { createLanguageAssistant } from "../api/createLanguageAssistant";

export const useCreateLanguageAssistantMutation = (languageCode: string) => {
  return useMutation({
    mutationKey: ["createLanguageAssistant", languageCode],
    mutationFn: createLanguageAssistant,
  });
};
